export const endPoints = {
  POST_CLEAR_NOTIFICATION: '/v1/notification/me/clear',
  GET_NOTIFICATION: '/v1/notification/me'
};
